export const GET_TENANT_DETAILS_REQUEST = "GET_TENANT_DETAILS_REQUEST";
export const GET_TENANT_DETAILS_SUCCESS = "GET_TENANT_DETAILS_SUCCESS";
export const GET_TENANT_DETAILS_FAILURE = "GET_TENANT_DETAILS_FAILURE";

export const GET_TENANT_LEASE = "GET_TENANT_LEASE";
export const GET_DEPENDENTS = "GET_DEPENDENTS";
export const GET_EMPTY = "GET_EMPTY";
